/*
 * @Date: 2023-04-09 18:26:07
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-25 14:03:06
 * @FilePath: \J1-M1-QRP-CODE\pages\restrict.js
 */
import React from "react";
import { Button } from 'antd';
import Header from '@/hayhar/header'; // 头部 组件

export default class Restrict extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
        this.openLiveChat = this.openLiveChat.bind(this);
        this.addAffiliateParamToUrl = this.addAffiliateParamToUrl.bind(this)
    }

    openLiveChat (){
        var CSLive = global.open(
            'about:blank',
            '_blank',
            'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=500, height=500'
        );
        CSLive.document.title = '竞博客服聊天窗口';
        CSLive.focus();
        CSLive.location.href = 'https://bilberryapp.hihi2u.com/app?';
    }

    addAffiliateParamToUrl(url) {
        return url;
    }

    render(){

        return(
            <div className="hayhar-page restrict">
                <Header pathname={'restrict'} openLiveChat={this.openLiveChat} addAffiliateParamToUrl={this.addAffiliateParamToUrl} ></Header>
                <div className="restrict-section-web">
                    <div className="IP-bg" > 
                        <div className="restrict-section-web-flex">
                           <div className="left">
                                <img  src="/static/images/restrict/guard.png" />
                           </div>
                            <div className="right">
                                <p className="p1">IP限制</p>
                                <p className="p2">对不起！您所在的区域</p>
                                <p className="p3">不在我们的服务范围内，若仍无法打开请尝试</p>
                                <p className="p4">刷新页面或联系在线客服。</p>

                                <div className="Btn">
                                    <Button className="bt1" onClick={()=>{window.location.reload();}}>刷新页面</Button>
                                    <Button className="bt2" onClick={()=>{this.openLiveChat()}}>联系客服</Button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div></div>
            </div>
        )
    }
}